// ============================================================================
// BonBoZ: các nút LỌC NHANH ở thanh trái, kiểu Pancake.
//
// Mỗi nút khai nó lọc bằng CƠ CHẾ nào:
//
//   'route'  — điều hướng sang route sẵn có của Chatwoot (chưa phản hồi, nhắc
//              tôi). Route đó tự mang điều kiện của nó.
//   'nguoi'  — đổi tab người phụ trách (của tôi / chưa phân công).
//   'server' — gắn thêm điều kiện vào truy vấn danh sách. `truyVan` là các tham
//              số gửi kèm; luật thi hành ở `Conversations::QuickFilter`.
//   'lich'   — mở lịch chọn khoảng, chọn xong thì gửi lên như 'server'.
//
// Mọi nút giờ đều lọc ở SERVER. Bản đầu lọc trong danh sách trình duyệt đã tải
// nên kết quả chỉ đúng trong 25 hội thoại đầu: bấm "chưa có SĐT" ra ba cái
// không có nghĩa là kho chỉ có ba khách chưa cho số, mà là trong 25 cái vừa tải
// có ba cái. Trực page không có cách nào biết mình đang nhìn mẫu hay nhìn kho.
//
// `loaiTru: '<nhom>'` = các mục cùng nhóm THAY THẾ nhau thay vì cộng dồn, vì
// cộng dồn chúng bằng VÀ thì kết quả luôn rỗng:
//   'sdt'       — hội thoại hoặc có số, hoặc không, không thể cả hai
//   'quang-cao' — tương tự, đến từ quảng cáo hoặc không
//   'ngay'      — mốc hoạt động không thể vừa "hôm nay" vừa "hôm qua"
//   'nhan-vien' — một hội thoại chỉ có MỘT người phụ trách
// Tag KHÔNG có loaiTru: một hội thoại mang được nhiều tag, nên chọn nhiều là
// hợp lý (và đã có chế độ VÀ/HOẶC riêng).
//
// `chiAdmin: true` = chỉ quản trị viên thấy nút. Lưu ý: đây là dọn giao diện,
// KHÔNG phải rào chắn. Nhân viên vẫn xem được mọi hội thoại trong trang họ được
// gán (app/models/user.rb:138 — chỉ giới hạn theo HỘP THƯ, không theo người phụ
// trách). Muốn giới hạn thật thì tách trang theo bộ phận.
//
// `mauNhom` = MAU NGU NGHIA cua nhom loc, khai o `_bonboz-theme.scss` va da
// chay qua bo kiem tuong phan + mu mau. Mau bam theo Y NGHIA chu khong theo
// thu tu: "cua ai" va "theo nhan vien" dung CHUNG mot mau vi cung noi ve
// nguoi. Mau chi hien khi nhom DANG loc - luc nghi thanh trai van xam, khong
// bien thanh cau vong.
// ============================================================================

// SĐT có thể nằm ở hồ sơ liên hệ (khách tự cho / nhân viên điền) hoặc chưa kịp
// đồng bộ mà mới nằm trong thuộc tính tuỳ chỉnh. Đọc cả hai cho chắc.
//
// Chỉ còn dùng để vẽ huy hiệu trên thẻ hội thoại. Bộ lọc "có SĐT" đã sang server
// và chỉ đọc `contacts.phone_number` — xem `Conversations::QuickFilter`.
export const coSoDienThoai = c => {
  const ttl = c.meta?.sender || {};
  const tt = ttl.custom_attributes || {};
  return Boolean(
    (ttl.phone_number || '').trim() ||
      (tt.kh_sdt || '').toString().trim() ||
      (tt.phone_number || '').toString().trim()
  );
};

// --------------------------------------------------------------- mốc thời gian
// MỘT mốc duy nhất cho mọi bộ lọc ngày: `last_activity_at` — lần hội thoại có
// động tĩnh gần nhất (khách nhắn hoặc nhân viên trả lời). Đây là thứ trực page
// thực sự hỏi ("hôm nay có gì cần xử lý"), không phải ngày khách nhắn lần đầu.
//
/** Server nhận GIÂY. Chia rồi làm tròn xuống, đừng gửi mili-giây. */
const giay = ms => Math.floor(ms / 1000);

export const NHOM_LOC = [
  {
    ten: 'viec-can-lam',
    mauNhom: 'var(--bonboz-cho)',
    nhan: 'BONBOZ.LOC_NHANH.NHOM_VIEC',
    icon: 'i-lucide-inbox',
    muc: [
      {
        ten: 'chua-phan-hoi',
        nhan: 'BONBOZ.LOC_NHANH.CHUA_PHAN_HOI',
        icon: 'i-lucide-message-square-warning',
        kieu: 'route',
        route: 'conversation_unattended',
      },
      {
        ten: 'chua-phan-cong',
        nhan: 'BONBOZ.LOC_NHANH.CHUA_PHAN_CONG',
        icon: 'i-lucide-user-x',
        kieu: 'nguoi',
        giaTri: 'unassigned',
        dem: 'unAssignedCount',
      },
      {
        ten: 'chua-doc',
        nhan: 'BONBOZ.LOC_NHANH.CHUA_DOC',
        icon: 'i-lucide-mail',
        kieu: 'server',
        // Cùng cột `unseen_since` mà thứ tự mặc định và huy hiệu đang dùng, nên
        // nút này không bao giờ lệch với chấm chưa xem trên thẻ hội thoại.
        truyVan: { unseen: true },
      },
      {
        ten: 'chua-gan-nhan',
        nhan: 'BONBOZ.LOC_NHANH.CHUA_GAN_NHAN',
        icon: 'i-lucide-tag',
        kieu: 'server',
        truyVan: { unlabeled: true },
      },
      // SĐT là mốc chốt của phòng khám: có số mới gọi lại và dò được hồ sơ
      // Epoint. Hai nút này là "đã xin được số chưa" — việc trực page phải
      // đuổi cho xong trong ca.
      {
        ten: 'co-sdt',
        nhan: 'BONBOZ.LOC_NHANH.CO_SDT',
        icon: 'i-lucide-phone',
        kieu: 'server',
        loaiTru: 'sdt',
        truyVan: { hasPhone: true },
      },
      {
        ten: 'chua-co-sdt',
        nhan: 'BONBOZ.LOC_NHANH.CHUA_CO_SDT',
        icon: 'i-lucide-phone-off',
        kieu: 'server',
        loaiTru: 'sdt',
        truyVan: { hasPhone: false },
      },
      // Chủ dự án chỉ cần biết có/không, không cần bóc từng mã quảng cáo:
      // việc trực page xử lý khách quảng cáo khác khách nhắn tự nhiên.
      {
        ten: 'tu-quang-cao',
        nhan: 'BONBOZ.LOC_NHANH.TU_QUANG_CAO',
        icon: 'i-lucide-megaphone',
        kieu: 'server',
        loaiTru: 'quang-cao',
        truyVan: { fromAd: true },
      },
      {
        ten: 'khong-tu-quang-cao',
        nhan: 'BONBOZ.LOC_NHANH.KHONG_TU_QUANG_CAO',
        icon: 'i-lucide-megaphone-off',
        kieu: 'server',
        loaiTru: 'quang-cao',
        truyVan: { fromAd: false },
      },
    ],
  },
  {
    ten: 'cua-ai',
    mauNhom: 'var(--bonboz-nguoi)',
    nhan: 'BONBOZ.LOC_NHANH.NHOM_NGUOI',
    icon: 'i-lucide-users',
    muc: [
      {
        ten: 'cua-toi',
        nhan: 'BONBOZ.LOC_NHANH.CUA_TOI',
        icon: 'i-lucide-user-check',
        kieu: 'nguoi',
        giaTri: 'me',
        dem: 'mineCount',
      },
      {
        ten: 'nhac-toi',
        nhan: 'BONBOZ.LOC_NHANH.NHAC_TOI',
        icon: 'i-lucide-at-sign',
        kieu: 'route',
        route: 'conversation_mentions',
      },
    ],
  },
  {
    ten: 'thoi-gian',
    mauNhom: 'var(--bonboz-mo)',
    nhan: 'BONBOZ.LOC_NHANH.NHOM_NGAY',
    icon: 'i-lucide-calendar-days',
    // Nhóm này KHÔNG có bảng chọn riêng: bấm vào là ra thẳng bảng lịch.
    //
    // Trước đây bấm biểu tượng lịch ra một bảng bốn mốc nhanh, muốn chọn khoảng
    // thì phải bấm thêm một lần nữa — mà hầu hết mọi người bấm tiếp thật. Bốn
    // mốc đó giờ nằm trong cột trái của bảng lịch, cùng chỗ với các mốc mới.
    kieuNhom: 'lich',
    muc: [],
  },
];

// ---------------------------------------------------------------- nhóm động
// Hai nhóm dưới đây KHÔNG khai cứng được: danh sách nhãn và danh sách nhân
// viên thay đổi theo tài khoản. Trả về theo dạng cùng cấu trúc với NHOM_LOC
// để QuickFilters.vue ghép vào và không phải biết gì thêm.

export function nhomTheoNhan(cacNhan = []) {
  return {
    ten: 'theo-nhan',
    mauNhom: 'var(--bonboz-tre)',
    nhan: 'BONBOZ.LOC_NHANH.NHOM_NHAN',
    icon: 'i-lucide-tags',
    // `laTag` cho QuickFilters biet day la muc CHON NHIEU (co the tick vai cai
    // cung luc, ket hop bang VA/HOAC) chu khong phai bo loc doc lap. Ca cum gui
    // len thanh MOT truy van nen tung muc khong mang `truyVan` rieng.
    muc: cacNhan.map(l => ({
      ten: `nhan:${l.title}`,
      nhanTho: l.title, // nhãn hiển thị nguyên văn, không qua i18n
      mau: l.color,
      laTag: true,
      tag: l.title,
      kieu: 'server',
    })),
  };
}

export function nhomTheoNhanVien(cacNhanVien = []) {
  return {
    ten: 'theo-nhan-vien',
    mauNhom: 'var(--bonboz-nguoi)',
    nhan: 'BONBOZ.LOC_NHANH.NHOM_NHAN_VIEN',
    icon: 'i-lucide-user-round',
    muc: cacNhanVien.map(a => ({
      ten: `nv:${a.id}`,
      loaiTru: 'nhan-vien',
      nhanTho: a.name,
      anh: a.thumbnail || a.avatar_url,
      kieu: 'server',
      truyVan: { assigneeId: a.id },
    })),
  };
}

// Khoảng ngày chọn trên bảng lịch. Nhận mili-giây hoặc Date.
//
// Gửi nguyên mốc nhận được, KHÔNG nới về trọn ngày nữa: bảng lịch đã gắn giờ
// trong ngày vào hai đầu khoảng bằng thanh trượt, nới thêm ở đây là xoá đúng
// thứ người dùng vừa chọn.
export function truyVanKhoang(tu, den, kieuNgay = 'updated') {
  return {
    activityAfter: giay(new Date(tu).getTime()),
    activityBefore: giay(new Date(den).getTime()),
    dateField: kieuNgay,
  };
}

/** `truyVan` có thể là hàm (mốc ngày, tính lúc bấm) hoặc object khai sẵn. */
export const docTruyVan = m =>
  typeof m?.truyVan === 'function' ? m.truyVan() : m?.truyVan || null;

// Danh sach hoi thoai vua dung lai tu dau — xay ra khi nguoi dung roi han khu
// hoi thoai (sang Thong ke, CRM...) roi quay lai, luc do ChatList dung lai va
// khong con nho bo loc nao. Thanh loc nam o thanh trai thi KHONG dung lai theo,
// nen phai tu tat: thieu no thi nut van sang va the hoi thoai van khoe moc gio
// tao trong khi danh sach da het loc.
export const SU_KIEN_DUNG_LAI = 'bonboz:loc-nhanh-dung-lai';

// Su kien tren bus dung chung (shared/helpers/mitt) giua thanh trai va danh
// sach hoi thoai. Hai component nay o hai nhanh khac han cua cay, khong the
// truyen prop qua duoc.
export const SU_KIEN_LOC = 'bonboz:loc-nhanh';
